import { SITE_ORIGIN, setJsonLd } from './site';

export function setMeta(key, content, property = false) {
  const attr = property ? 'property' : 'name';
  const matches = [...document.head.querySelectorAll(`meta[${attr}="${key}"]`)];
  const el = matches.shift() || document.createElement('meta');
  matches.forEach(node => node.remove());
  el.setAttribute(attr, key);
  if (el.getAttribute('content') !== content) el.setAttribute('content', content);
  if (!el.isConnected) document.head.appendChild(el);
}

export function setCanonical(path) {
  const matches = [...document.head.querySelectorAll('link[rel="canonical"]')];
  const el = matches.shift() || document.createElement('link');
  matches.forEach(node => node.remove());
  el.rel = 'canonical';
  const url = SITE_ORIGIN + path;
  if (el.getAttribute('href') !== url) el.setAttribute('href', url);
  if (!el.isConnected) document.head.appendChild(el);
}

export function setNoindex() { setMeta('robots', 'noindex, follow'); }

export function socialImage(image, alt = 'Regal Tuning') {
  const url = image?.startsWith('http') ? image : SITE_ORIGIN + (image || '/assets/workshop/dyno-lambo.webp');
  setMeta('og:image', url, true);
  setMeta('og:image:alt', alt, true);
  setMeta('twitter:image', url);
  setMeta('twitter:image:alt', alt);
}

export function breadcrumb(id, items) {
  setJsonLd(id, { '@context': 'https://schema.org', '@type': 'BreadcrumbList',
    itemListElement: items.map(([name, path], i) => ({ '@type': 'ListItem', position: i + 1, name, item: SITE_ORIGIN + path })) });
}